import * as types from 'modules/dealerConfiguration/sales/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} State */

/** @type {State} */
const initialState = false;

const isLoading = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [types.FETCH_FLEETBACK_MEDIAS_CLIPPING_REQUEST]: isLoading,
  [types.FETCH_FLEETBACK_MEDIAS_CLIPPING_SUCCESS]: isEnded,
  [types.FETCH_FLEETBACK_MEDIAS_CLIPPING_FAILURE]: isEnded,
});
